// extracted by mini-css-extract-plugin
export default {"info":"D0qxYzk2qI","h-rule":"Pfrjd5A0Hp","hRule":"Pfrjd5A0Hp","logo":"dsN0aI9Esc","further-resources":"QmgBiv_lak","furtherResources":"QmgBiv_lak"};